module.exports = __webpack_public_path__ + "img/undraw_at_home_octe.ca4e73e0.svg";